import { createFileRoute } from '@tanstack/react-router';
import WorkQueue from 'containers/WorkQueue';

export const Route = createFileRoute('/_authenticated/workQueue')({
  component: WorkQueue,
});
